module.exports = __webpack_public_path__ + "static/media/dish-13.8131e4a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dishes/dish-13.jpg
// module id = 509
// module chunks = 0